import React, { useState, useRef, useEffect } from "react";
import "./info-icon.scss";
import { InfoIcon } from "../../SVG/infoIcon";

type Direction = "left" | "right" | "top" | "bottom";

interface InfoIconProps {
  content: React.ReactNode;
  className?: string;
  maxWidth?: number; // in rem
  maxHeight?: number; // in rem
  directionToDisplay?: Direction;
}

export const InfoIconWithTooltip: React.FC<InfoIconProps> = ({
  content,
  className = "",
  maxWidth,
  maxHeight,
  directionToDisplay = "bottom",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const iconRef = useRef<HTMLDivElement>(null);
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        iconRef.current &&
        !iconRef.current.contains(event.target as Node) &&
        popoverRef.current &&
        !popoverRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const popoverStyle = {
    width: maxWidth ? `${maxWidth}rem` : undefined,
    maxHeight: maxHeight ? `${maxHeight}rem` : undefined,
  };

  return (
    <div className={`info-icon-container ${className}`}>
      <div
        ref={iconRef}
        className="info-icon"
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            setIsOpen(!isOpen);
          }
        }}
        aria-label="Information"
      >
        <InfoIcon />
      </div>
      {isOpen && (
        <div
          ref={popoverRef}
          className={`info-popover ${directionToDisplay}`}
          style={popoverStyle}
        >
          {content}
        </div>
      )}
    </div>
  );
};
